import { CustomerListFragment, ReferenceCustomerFragment } from 'src/api/api.generated'
import { DocumentCustomerFormSchema } from 'src/app/components/document-customer-input/document-customer-schema'

export function getCustomerFromCustomerListFragment(customer: CustomerListFragment): DocumentCustomerFormSchema {
  return {
    id: customer.id,
    name: customer.name,
    address: customer.address?.address ?? '',
    city: customer.address?.city ?? '',
    countryCode: customer.address?.country?.isoCode ?? undefined,
    fiscalCode: customer.fiscalCode,
    municipalityId: customer.address?.municipalityId ?? undefined,
    splitPayment: customer.type === 'COMPANY' ? customer.company?.splitPayment ?? false : false,
    email: customer.mailContacts?.find((e) => e.isDefault)?.value ?? undefined,
    vatNumber: customer.vatNumber ?? '',
  }
}

export function getCustomerFromReferenceCustomerFragment(c: ReferenceCustomerFragment): DocumentCustomerFormSchema {
  return {
    id: c.id,
    name: c.name,
    address: c.address?.address ?? '',
    city: c.address?.city ?? '',
    countryCode: c.address?.country?.isoCode ?? undefined,
    province: c.address?.province ?? '',
    municipalityId: c.address?.municipalityId ?? undefined,
    fiscalCode: c.fiscalCode,
    vatNumber: c.vatNumber,
    splitPayment: c.type === 'COMPANY' ? c.company?.splitPayment ?? false : false,
    email: c.mailContacts?.find((e) => e.isDefault)?.value ?? undefined,
  }
}
